import { useState, useEffect} from 'react';
import './About.css';

const About = () => {

    const [onHover, setOnHover] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {

        window.addEventListener('resize', handleWindowsSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowsSizeChange);
        }

    }, []);

    function handleWindowsSizeChange() {
        setWidth(window.innerWidth);
    }

    return (
        <div className="about-container">
            {width <= 768 ? (
                <div className='video-mobile'>
                    <video autoPlay muted loop playsInline className='video-about-block'>
                        <source src={`${process.env.PUBLIC_URL}/about.mp4`} />
                    </video>
                </div>
            ) : (
                onHover && (
                    <div className={`video-about`}>
                        <video autoPlay muted loop playsInline className='video-about-block'>
                            <source src={`${process.env.PUBLIC_URL}/about.mp4`} />
                        </video>
                    </div>
                )
            )}
            <div className='description-block' onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}>
                <span>SEBASCOTO</span>{" | DIRECTOR, CREATIVE DIRECTOR & EDITOR. \uD83D\uDCCD LA \u2022 CDMX."}<br /><br />
                {"DEFINED BY A DECADE OF MIXED-MEDIA INNOVATION AND BY HARNESSING THE TENSION BETWEEN GENERATIVE TECH AND ANALOG SOUL, I POSITION EMPATHY AS THE CORE ENGINE OF MY NARRATIVE. I CRAFT VISUALS THAT ARE NOT ONLY POWERFUL AND EFFECTIVE BUT DEEPLY ROOTED IN HUMAN CONNECTION AND ARCHITECTURAL PRECISION."}
            </div>

            <h3 className="about-title">PRESS & FEATURES</h3>
            <ul className='about-ul'>
                <li><a href='https://directorslibrary.com/2020/latest/music-videos/aguita-gabriel-garzon-montano/' target="_blank" rel="noreferrer">DIRECTORS LIBRARY</a></li>
                <li><a href='https://imvdb.com/video/coco-jones/on-sight' target="_blank" rel="noreferrer">IMVDB</a></li>
                <li><a href='https://bamv.net/video/aun-asi-soy-necio-424/'target="_blank" rel="noreferrer">BAMV PICKS</a></li>
            </ul>

            <h3>FESTIVALS</h3>
            <ul className='about-ul'>
                <li>VIDEO PRISMA AWARDS</li>
                <li><a href='https://www.onepointfour.co/entries/sebas-coto-aguita/' target="_blank" rel="noreferrer">ONEPOINTFOUR</a></li>
                <li><a href='https://bogotamvf.com/post/635807138316500992/selecci%C3%B3n-oficial-bmvf-2020-competencia' target="_blank" rel="noreferrer">BOGOTÁ MUSIC VIDEO AWARDS</a></li>
            </ul>

            <h3>CLIENTS</h3>
            <ul className='about-ul'>
                <li>FOREVER 21</li>
                <li>SPOTIFY</li>
                <li>SEAGRAMS ESCAPES</li>
                <li>DEF JAM RECORDINGS</li>
                <li>STEVE AOKI</li>
                <li>SONY MUSIC US LATIN</li>
                <li>DEBI NOVA</li>
                <li>WARNER MUSIC LATINA</li>
                <li>JAGJAGUWAR</li>
                <li>SONY MUSIC SPAIN</li>
                <li>CALONCHO</li>
                <li>DIM MAK</li>
                <li>DOMESTIKA</li>
                <li>COCO JONES</li>
                <li>NEW CYCLE</li>
                <li>ADIDAS ORIGINALS</li>
                <li>GREY</li>
                <li>NEW BALANCE</li>
                <li>KENIA OS</li>
                <li>HYBE</li>
                <li>ADIDAS</li>
                <li>JAZE</li>
            </ul>
        </div >
    );
}

export default About;